<template>
    <div class="footer">
        <div class="footer_content">
            <div class="footer_c_introduce">
                <span>运维保障：四川党建平台运维服务中心</span>
                <span>蜀ICP 备 11013593号 © 2019</span>
                <span>联系电话：028-86600337</span>
                <span>邮箱地址：sc1237123@126.com</span>
            </div>
            <div class="footer_c_QRcode">
                <div class="footer_QRcode_item" v-for="item in picList" :key="item">
                    <img :src="item.url" :alt="item.label" />
                    <span class="item_text">{{ item.label }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
const picList = ref([
    {
        url: require('../../../assets/images/wxgzh.jpg'),
        label: '四川党建公众微信号',
    },
    // {
    //     url: require('../../../assets/images/appaz.png'),
    //     label: '四川党建APP（安卓端）',
    // },
    // {
    //     url: require('../../../assets/images/sppios.png'),
    //     label: '四川党建(IOS端)',
    // },
]);
</script>

<style lang="scss" scoped>
.footer {
    height: 281px;
    //   position: fixed;
    //   bottom: 0;
    background: url(../../../assets/images/footer.png) no-repeat;
    background-size: 100% 100%;
    position: relative;
    .footer_content {
        width: 1190px;
        height: 80%;
        position: absolute;
        top: 50%;
        left: 50%;
        // background-color: rgba(23, 14, 158, 0.2);
        transform: translate(-50%, -50%);
        display: flex;
        justify-content: space-between;
        align-items: center;
        .footer_c_introduce {
            height: 113px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 0 40px;
            border-left: 7px solid #eb0100;
            font-size: 18px;
        }
        .footer_c_QRcode {
            display: flex;
            :nth-child(2) {
                margin: 0 20px;
            }
            .footer_QRcode_item {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: space-between;
                margin-top: 20px;
                img {
                    width: 137px;
                    height: 137px;
                }
                .item_text {
                    font-size: 16px;
                    display: inline-block;
                    margin-top: 20px;
                }
            }
        }
    }
}
</style>